import { inject, Injectable } from '@angular/core';
import { BaseValidationService } from '@luzula/luzula-lib';
import { AuthService } from '../auth.service';
import { DataService } from '../data.service';

@Injectable({
	providedIn: 'root'
})
export class ValidationService extends BaseValidationService {
	private auth = inject(AuthService);
	private ds = inject(DataService);

	constructor() {
		super();
		// Bohrpunkte-spezifische Validatoren registrieren

		// beispielhaft für Sandbox-Liste
		this.registerValidator("aListOption", (data) => {
			const num = data as string | number;
			switch (num) {
				case '4':
				case 4: return this.warning("Ganz schön viel");
				case '5':
				case 5: return this.danger("Bitte nicht die 5!!");
				default: return this.ok();
			}
		});

		this.registerValidator("Vegetations-Anteil", (s: unknown) => {
			// Leere Werte sind ok - erst validieren wenn etwas eingetragen wurde
			if (s === undefined || s === null || s === '') return this.ok();
			const str = String(s).trim();
			if (str === '') return this.ok();
			if (str === 'r') return this.ok();
			if (str === '+') return this.ok();
			const n = parseFloat(str);
			if (n <= 0 || n > 100 || isNaN(n)) return this.danger("Ungültiger Wert (Zahl oder r,+)");
			else return this.ok();
		});

		const wasserformValidator = (s: unknown) => {
			const str = s as string;
			if (!str) return this.ok();
			const valid = /^[0-9+xˣ⁺]+$/i.test(str);
			if (!valid) return this.danger("Nur Ziffern, + und x erlaubt");
			return this.ok();
		};
		this.registerValidator("Wasserform", wasserformValidator);
		this.registerValidator("Wasserform2", wasserformValidator);
	}

	/**
	 * Gibt den aktuellen Benutzernamen zurück
	 */
	protected override getCurrentUser(): string {
		return this.auth.currentUser;
	}

	/**
	 * Speichert den aktuellen Kontext (Bohrpunkt) mit den Kommentaren
	 */
	protected override saveContext(): void {
		if (this.context) {
			this.setValidationState(); // ValidationState aktualisieren vor dem Speichern
			this.ds.saveDocument(this.context, { user: this.auth.currentUser });
		}
	}
}
